import React from 'react';

import ArrowIcon from '../../../assets/icons/faq/ArrowIcon';

import styles from './styles.module.scss';

const FaqItem = ({ faqData, ...props }) => {
  const { link, text, img: Image } = faqData;
  return (
    <li className={styles.faqItem} {...props}>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <span>
          <Image />
        </span>
        {text}
        <span className={styles.faqArrow}>
          <ArrowIcon></ArrowIcon>
        </span>
      </a>
    </li>
  );
};

export default FaqItem;
